export default __webpack_public_path__ + "static/media/icon-call-decline.c05dcb79.svg";